"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputFormat = void 0;
var OutputFormat;
(function (OutputFormat) {
    OutputFormat["KeyedJsonObject"] = "object";
    OutputFormat["Array"] = "array";
})(OutputFormat = exports.OutputFormat || (exports.OutputFormat = {}));
//# sourceMappingURL=Definitions.js.map